<button id="btnPrimary" class="btn btn-md btn-block" (click)="onClick()" [disabled]="disabled" [autofocus]="hasFocus">
  <mat-icon *ngIf="showTick" id="iconTick" class="icon mr-2">done</mat-icon>
  <mat-icon *ngIf="showBookmark" id="iconBookMark" class="icon mr-2">bookmark</mat-icon>
  <span *ngIf="textOnly(); else elseBlock" class="mx-auto" [class.disable-span]="disabled" [innerHTML]="text | safeHtml"></span>
  <ng-template #elseBlock>
    <span id="spanText" [class.disable-span]="disabled" [innerHTML]="text | safeHtml"></span>
  </ng-template>
  <span *ngIf="detail" class="ml-auto"  [innerHTML]="detail | safeHtml"></span>
</button>
